// extracted by mini-css-extract-plugin
export default {"container":"vM-z","topReviewHeading":"wM-z","criticalReview":"xM-z","favorableReview":"yM-z","vsSeparator":"zM-z"};